<script setup>
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';

import Button from 'next/button/Button.vue';
import ViewWrapper from './ViewWrapper.vue';

const { t } = useI18n();
const router = useRouter();
const store = useStore();

const heroImage = '/dashboard/images/onboarding/wgpt_get_started.svg';

const completeOnboarding = async () => {
  try {
    await store.dispatch('wgptOnboarding/complete');
  } finally {
    window.location.assign('/');
  }
};
</script>

<template>
  <ViewWrapper>
    <div class="flex flex-col items-center justify-center text-center">
      <img :src="heroImage" alt="Get started" class="w-64 h-auto mb-8" />
    </div>

    <template #actions>
      <Button
        :label="t('WGPT_ONBOARDING.WELCOME.SKIP')"
        variant="link"
        color="slate"
        size="sm"
        @click="completeOnboarding"
      />
      <Button
        lg
        :label="t('WGPT_ONBOARDING.WELCOME.CTA')"
        @click="router.push({ name: 'wgpt_onboarding_integrations' })"
      />
    </template>
  </ViewWrapper>
</template>
